import {
    collection,
    query,
    orderBy,
    limit,
    getDocs,
    where,
} from "firebase/firestore";
import React, { useEffect, useState } from 'react'
import { db } from '../../../Firebase/firebase_init';
import { useInView } from "react-intersection-observer";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import SubTitle from "../MainComponents/SubTitle";
import { colorLogo, theme } from "../../../Resources/Design/theme";
import Article from "./Article";
import BaseButton from "../../BaseButton";
import { Motion } from "../../Motion";
import { fontLink, fullCenter, useMobile } from "../../../base";
import LangLink from "../../../Localization/LangLink";
import { Txt } from "../../../Routes/Localized";
import { useBlog } from "../../../Firebase/BlogProvider";


export default function BlogLayout({ sx = {} }) {
    const mobile = useMobile();
    const { getRandomArticles } = useBlog();
    const oneArticle = useMediaQuery("(max-width:750px)");
    const twoArticles = useMediaQuery("(max-width:1050px)");

    const articles = getRandomArticles(3);

    if (articles && articles.length === 0) {
        return <></>;
    }

    return (
        <Box
            sx={{

            }}>
            <SubTitle
                title={<Txt id={"20023"} />}
                sx={{
                    [theme.breakpoints.down('md')]: {
                        pb: '60px',
                        pt: '0px',
                    },
                    ...sx
                }}
            />
            {Boolean(articles) && <Grid container spacing={4}>
                {articles.map((article, item) => {
                    return (
                        <Grid
                            key={item}
                            item
                            xs={12}
                            sm={oneArticle ? 12 : 6}
                            md={twoArticles ? 6 : 4}
                            lg={4}
                            sx={{ ...(mobile && { mx: '16px !important' }) }}
                        >
                            <Article {...article} />
                        </Grid>
                    )
                })}
            </Grid>}

            <Box sx={{
                width: '100%', ...fullCenter,
                mt: { xs: '40px', sm: '40px', md: '80px' },
                mb: { xs: '40px', sm: '40px', md: '40px' }
            }}>
                <Motion scale={1.02}>
                    <Box
                        component={LangLink}
                        to='/blog'
                        sx={{
                            m: '8px',
                            minWidth: '142px',
                            height: '55px',
                            borderRadius: "999px",
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#0165F4",
                            ":hover": { backgroundColor: "#0165F4" },
                            ...fullCenter,
                            cursor: 'pointer',
                            textDecoration: 'none'
                        }}

                    >
                        <Typography sx={{ color: 'white', fontWeight: 'bold', px: '16px', ...fontLink, }}>
                            <Txt id={"20019"} />
                        </Typography>
                    </Box>
                </Motion>
            </Box>
        </Box>
    )
}
